import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React from 'react';
import PropTypes from 'prop-types';
import useSWR from 'swr';
import { Icon } from '@mch-group/uikit-components';
import { CuratorFinder } from '@dmi-mch/services';
import { buildSelectOptions, validateAxiosResponse as ValidateAxiosResponse, logger as Logger } from '@dmi-mch/utils';
import CMultiSelect from './common/CMultiSelect';

var _ = require('lodash');

var CuratorSelector = function CuratorSelector(props) {
  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      options = _React$useState2[0],
      setOptions = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      values = _React$useState4[0],
      setValues = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isLoading = _React$useState6[0],
      setIsLoading = _React$useState6[1];
  /* get saved curator by curatorId from api */
  // Userprofile_2000252 - is a WAG for curators


  var fetchUrl = "/msvc/v1/userprofiles/resolution/resolve/Userprofile_2000252/".concat(props.curatorId);

  var fetcher = function fetcher(url) {
    return props.context.http.get(url).then(function (res) {
      return res.data;
    });
  };

  var _useSWR = useSWR(props.curatorId && !options ? fetchUrl : null, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  }),
      curators = _useSWR.data;

  React.useEffect(function () {
    if (curators && !options) {
      var selectItem = {
        key: 'entityId',
        value: 'entityId',
        text: 'title',
        name: 'title'
      };
      var dropdownOptions = buildSelectOptions([curators], selectItem);
      setOptions(dropdownOptions);
      setValues(curators.entityId);
      props.setFieldValue(props.fieldName, curators.entityId);
    }
  }, [curators, options, props]);

  var fetchData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var curatorFinderService, curatorList, selectItem, newList, dropdownOptions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.prev = 1;
              curatorFinderService = new CuratorFinder(props.context);
              _context.t0 = value;

              if (!_context.t0) {
                _context.next = 8;
                break;
              }

              _context.next = 7;
              return curatorFinderService.search(value);

            case 7:
              _context.t0 = _context.sent;

            case 8:
              curatorList = _context.t0;
              setIsLoading(false);

              if (ValidateAxiosResponse(curatorList)) {
                selectItem = {
                  key: 'entityId',
                  value: 'entityId',
                  text: 'title',
                  name: 'title'
                };
                newList = _.uniqWith(curatorList.data, _.isEqual);
                dropdownOptions = buildSelectOptions(newList, selectItem);
                setOptions(dropdownOptions);
              }

              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t1 = _context["catch"](1);
              Logger(_context.t1);
              setIsLoading(false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 13]]);
    }));

    return function fetchData(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var debounceLoadData = React.useCallback(_.debounce(fetchData, 1000), []);

  var onSearchChange = function onSearchChange(event) {
    var value = event.target.value;
    debounceLoadData(value);
  };

  return /*#__PURE__*/React.createElement(CMultiSelect, {
    options: options,
    placeholder: props.placeholder,
    displayValue: "text",
    closeOnSelect: true,
    showArrow: true,
    loading: isLoading // eslint-disable-next-line no-unused-vars
    ,
    onSelect: function onSelect(selectedList, selectedItem) {
      props.setFieldValue(props.fieldName, selectedItem.value);
      setValues(selectedItem.value);
    } // eslint-disable-next-line no-unused-vars
    ,
    onRemove: function onRemove(selectedList, removedItem) {
      props.setFieldValue(props.fieldName, '');
      setValues('');
    },
    onSearch: function onSearch(searchBy) {
      onSearchChange(searchBy);
    },
    selectedValues: values ? values && values.map(function (item) {
      return {
        key: item.key,
        value: item.value,
        text: item.text,
        name: item.value
      };
    }) : [],
    customArrow: /*#__PURE__*/React.createElement(Icon, {
      name: "caret-down",
      color: "#000",
      size: 20,
      style: {
        marginBottom: 20
      }
    })
  });
};

CuratorSelector.propTypes = {
  setFieldValue: PropTypes.func,
  context: PropTypes.object,
  fieldName: PropTypes.string,
  curatorId: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string
};
CuratorSelector.defaultProps = {
  value: '',
  curatorId: ''
};
export default CuratorSelector;